import signedFetch from '../apiCalls/util/signedFetch';

export default classId =>
  signedFetch('getOrgAndClassDetailsByClassId', `${__API_BASE__}/class/${classId}/getOrgAndClassDetails`, 'GET');
